import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { DividendPaymentKey } from 'api/Trading-Accounts/Types/DividendsDto'
import { generateClassNameForReverseType } from 'helpers/transactions'
import { formatLocalDateUTC } from 'utils/date'
import { isEmpty } from 'utils/is-empty'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

const customCorporateActionColumns: GridColumn[] = [
  {
    title: 'Broker Symbol',
    field: DividendPaymentKey.brokerSymbol,
    cell: (props: GridCellProps): JSX.Element => {
      const brokerSymbol = props.dataItem?.exchangeSymbol
      if (isEmpty(brokerSymbol)) {
        return <td className={generateClassNameForReverseType(props.dataItem)} />
      }

      return <td className={generateClassNameForReverseType(props.dataItem)}>{brokerSymbol}</td>
    },
    filter: 'text',
    width: 140,
    sortable: false,
    show: true,
    resizable: true,
  },
  {
    title: 'Company Name',
    field: DividendPaymentKey.companyName,
    cell: (props: GridCellProps): JSX.Element => {
      const companyName = props.dataItem?.companyName
      if (isEmpty(companyName)) {
        return <td className={generateClassNameForReverseType(props.dataItem)} />
      }

      return <td className={generateClassNameForReverseType(props.dataItem)}>{companyName}</td>
    },
    filter: 'text',
    sortable: false,
    show: true,
  },
  {
    title: 'Corporate Event Type',
    field: 'eventSubType.name',
    cell: (props: GridCellProps): JSX.Element => {
      if (!props.dataItem.eventSubType) {
        return <td />
      }
      return <td className='columns__content'>{props.dataItem.eventSubType.name}</td>
    },
    filter: 'text',
    sortable: false,
    show: true,
  },
  {
    title: 'Corporate Event Date',
    field: 'eventDate',
    cell: (props: GridCellProps): JSX.Element => {
      if (!props.dataItem.eventSubType) {
        return <td />
      }
      return (
        <td className={generateClassNameForReverseType(props.dataItem, 'date')}>
          {formatLocalDateUTC(props.dataItem.eventDate)}
        </td>
      )
    },
    filter: 'text',
    resizable: false,
    sortable: true,
    show: true,
  },
]

export default customCorporateActionColumns
